import { Nullable } from './shared-types'

export interface SolarResponse<TResponse> {
  reason: string
  msgCode: Nullable<string>
  succeeded: boolean
  data: TResponse
}

export interface SolarPagination {
  title: string
  start: number
  length: number
  recordsFiltered: number
  recordsTotal: number
}

export type SolarPagedResponse<TResponse> = SolarResponse<TResponse> & SolarPagination

export class SolarResponseRefiner<TResponse> {
  constructor(private response: SolarResponse<TResponse>) {}

  get isError() {
    return this.response.succeeded === false
  }

  public handle = (): TResponse | null | never => {
    if (this.isError) {
      throw new SolarServiceError(this.response.reason)
    }
    return this.response.data || null
  }
}

export class SolarServiceError extends Error {
  constructor(message: string) {
    super(message)
    this.name = this.constructor.name
  }
}
